import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ListaMetricas } from "../../Components/informes";

function Informes() {
  const navigate = useNavigate();
  const session = useSelector((store) => store.auth);

  useEffect(() => {
    if (!session) navigate("/");
  }, [session]);

  return (
    <Container>
      <ListaMetricas />
    </Container>
  );
}

export default Informes;

export const Container = styled.div`
  padding: 0 0 0 var(--navbar-size);
  min-height: 100vh;
`;
